export type InscribeRiskLevel = "LOW" | "MEDIUM" | "HIGH" | "NOT_APPLICABLE";

type RiskStatus = "Rejected" | "Warning" | "Accepted";

export const parseRiskLevel = (
  riskLevel?: InscribeRiskLevel | string | null
): RiskStatus | undefined => {
  switch (riskLevel) {
    case "HIGH":
      return "Rejected";
    case "MEDIUM":
      return "Warning";
    case "LOW":
      return "Accepted";
    default:
      return undefined;
  }
};
